import types from './types';

export const getDefaultDataView = (entityType, id, latestDataViewId, isDeleted, otherParams) => ({
  type: types.GET_DEFAULT_DATAVIEW,
  params: { entityType, id, latestDataViewId, isDeleted, ...otherParams }
});

export const getDataViewList = entityType => ({
  type: types.GET_DATAVIEW_LIST,
  params: { entityType }
});

export const getFavoriteDataViewList = () => ({
  type: types.GET_FAVORITE_DATAVIEW_LIST
});

export const createNewDataView = (dataViewName, entityType, filterState, filters) => ({
  type: types.CREATE_NEW_DATAVIEW,
  params: { dataViewName, entityType, filters, ...filterState }
});

export const deleteDataView = (id, entityType) => ({
  type: types.DELETE_DATAVIEW,
  params: { id, entityType }
});

export const lockUnlockDataView = (id, entityType) => ({
  type: types.LOCK_DATAVIEW,
  params: { id, entityType }
});

export const favoriteUnfavoriteDataView = (id, entityType) => ({
  type: types.FAVORITE_DATAVIEW,
  params: { id, entityType }
});

export const clearDefaultFilteredList = () => ({
  type: types.CLEAR_DEFAULT_FILTERED_LIST
});

export const clearSharedDataView = () => ({
  type: types.CLEAR_SHARED_DATA_VIEW
});

export const getShareUrlDataView = (
  sharedDataViewName,
  dataViewId,
  entityType,
  filterState,
  filters
) => ({
  type: types.GET_SHARE_URL_DATAVIEW,
  params: { sharedDataViewName, dataViewId, entityType, filters, ...filterState }
});

export const shareDataView = (sharedDataViewName, sharedDataView, entityType) => ({
  type: types.SHARE_DATAVIEW,
  params: { sharedDataViewName, sharedDataView, entityType }
});

export default {
  getDefaultDataView,
  getDataViewList,
  getFavoriteDataViewList,
  createNewDataView,
  deleteDataView,
  lockUnlockDataView,
  favoriteUnfavoriteDataView,
  clearDefaultFilteredList,
  clearSharedDataView,
  getShareUrlDataView,
  shareDataView
};
